<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :isEdit="isEdit"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
        :manualPackagingPrice="true"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    extras: null,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  created(){
    // console.log("edit", this.entry, this.editableEntry);
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      // this.editableEntry.item = {};
      // this.editableEntry.item = loadEntry.item;
      // console.log("load", loadEntry);
      // console.log("load2", this.editableEntry);
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALE_PRODUCT_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry.validations = response.data.accountContext.dummySaleOrderProduct.validations;
          this.extraData = response.data;
          this.extraData.customerId = this.extras.customerId;
          this.extraData.paymentConditionRuleId = this.extras.paymentConditionRuleId;
          this.extraData.accountContext.accountPermissions = this.extras.accountContext.accountPermissions;
          // this.editableEntry.item = {};
          this.editableEntry.itemAux = _.cloneDeep(loadEntry.item);
          // console.log("load3", loadEntry);
          // console.log("load4", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        console.log("or,ed", this.originalEntry, this.editableEntry);
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_SALE_PRODUCT_QUERY = gql `
  {
    accountContext {
      dummySaleOrderProduct {
        validations
      }

      allStorages {
        id
        name
        location
      }
      availableItemsForSale {
        id
        name
        unit {
          id
          name
        }
      }
    }
  }
`;
</script>

<style scoped></style>
